import React from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import "./experienceData.scss";

export const ExperienceData = () => {
  const { t } = useTranslation();

  return (
    <div className="wrapper_exp_data">
      <div className="container-lg">
        <div className="content_exp_data">
          {/* Años de experiencia */}
          <div className="item_exp_data">
            <span className="data_big color">
              +
              <CountUp
                start={5}
                end={15}
                duration={3.75}
                enableScrollSpy
                scrollSpyDelay={250}
              >
                {({ countUpRef }) => <span ref={countUpRef} />}
              </CountUp>
            </span>
            <span className="data_text">{t("Años de experiencia.")}</span>
          </div>

          {/* Proyectos exitosos */}
          <div className="item_exp_data">
            <span className="data_big">
              +
              <CountUp
                start={2300}
                end={2465}
                duration={3.75}
                enableScrollSpy
                scrollSpyDelay={250}
              >
                {({ countUpRef }) => <span ref={countUpRef} />}
              </CountUp>
            </span>
            <span className="data_text">{t("Proyectos exitosos.")}</span>
          </div>

          {/* Clientes satisfechos */}
          <div className="item_exp_data">
            <span className="data_big color">
              +
              <CountUp
                start={500}
                end={576}
                duration={3.75}
                enableScrollSpy
                scrollSpyDelay={250}
              >
                {({ countUpRef }) => <span ref={countUpRef} />}
              </CountUp>
            </span>
            <span className="data_text">{t("Clientes satisfechos.")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
